import { toSpecialFixed } from '@/lib/misc/utils';
import { IoIosArrowRoundForward } from 'react-icons/io';
import { IoTriangle } from 'react-icons/io5';
import { TbTriangleInvertedFilled } from 'react-icons/tb';
import { useState } from 'react';
import EthDetailsModal from './EthDetailsModal';
import Image from 'next/image';
import { ImageWithFallback } from '@/components/shared/NextImageFallback';
export default function NativeTokenItem({
  tokenItem,
  timeFrame,
  searchResult,
  handleTokenClick,
  onTokenClick,
  mode
}) {
  const isEthereum = tokenItem?.symbol === 'ETH' && mode === 'native';
  const change = parseFloat(searchResult?.[`change${timeFrame}`]);
  const [isModalOpen, setIsOpenModal] = useState(false);
  function toggleModal() {
    setIsOpenModal(!isModalOpen);
  }
  return <div className='flex items-center' data-sentry-component="NativeTokenItem" data-sentry-source-file="NativeTokenItem.tsx">
      {' '}
      <div onClick={() => {
      if (isEthereum) {
        toggleModal();
      } else {
        handleTokenClick(tokenItem, searchResult);
      }
    }} key={`${tokenItem?.name}`} className={`h-[80px] flex px-4 w-full   justify-between items-center hover:cursor-pointer md:hover:bg-genius-blue relative`}>
        <div className='flex items-center gap-3 relative w-full   '>
          <ImageWithFallback src={tokenItem?.imageSmallUrl || tokenItem?.info?.imageThumbUrl} width={24} height={24} alt='token-logo' className='rounded-full tokenImg' data-sentry-element="ImageWithFallback" data-sentry-source-file="NativeTokenItem.tsx" />

          <div className={`flex flex-col justify-start text-left`}>
            <p className={`text-base/4 text-genius-cream font-light flex items-center`}>
              {tokenItem?.name}
              {isEthereum ? <div className='flex items-center text-[12px] text-genius-cream/50 ml-2'>
                  Details <IoIosArrowRoundForward className='w-[16px] h-[16px]' />{' '}
                </div> : <></>}
            </p>
          </div>
        </div>
        <div className={`flex flex-col text-right gap-y-2 max-w-18 text-wrap ${mode === 'recent' && 'pr-6'}`}>
          <p className='text-base/4 text-genius-cream text-right text-wrap'>
            ${toSpecialFixed(searchResult.priceUSD, 2, true).value}
          </p>
          <div className='flex gap-1 items-center justify-end text-right'>
            {change >= 0 ? <div className='flex items-center text-right'>
                <IoTriangle color='#34D399' size={12} />
                <p className='text-xs text-gray-400 ml-1 text-right'>{`${toSpecialFixed(change * 100, 2)?.value}%`}</p>
              </div> : <div className='flex items-center text-right'>
                <TbTriangleInvertedFilled color='#FF5B5B' size={12} />
                <p className='text-xs text-red-400 ml-1 text-right'>{`${toSpecialFixed(Math.abs(change * 100), 2).value}%`}</p>
              </div>}
          </div>
        </div>
      </div>
      {isEthereum && <EthDetailsModal onTokenClick={onTokenClick} isModalOpen={isModalOpen} toggleModal={toggleModal} change={change} price={searchResult.priceUSD} />}
    </div>;
}